var _effectorFileName = "/src/page-content/home/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const homePage = declarePage({
  pageType: pagesPath.$url().pathname
});